import { Map } from 'immutable'
import RegistrationPageContexts from 'aria-viewer/registration/RegistrationPageContexts'
import {
    SET_REGISTRATION_PAGE_CONTEXT,
    SET_REGISTRATION_ATTRIBUTES,
    SET_REGISTRATION_FORMTYPE,
} from 'aria-viewer/registration/registrationActions'

const INITIAL_STATE = Map({
    registrationPageContext: RegistrationPageContexts.DESKTOP_LANDING,
    registrationAttributes: null,
    formType: 'legacy',
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_REGISTRATION_PAGE_CONTEXT:
            return state.set('registrationPageContext', action.registrationPageContext)
        case SET_REGISTRATION_ATTRIBUTES:
            return state.set('registrationAttributes', action.attributes)
        case SET_REGISTRATION_FORMTYPE:
            return state.set('formType', action.formType)
        default:
            return state
    }
}
